import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./Header.css";

function Header({ home, setHome, aboutMe, setAboutMe, contact, setContact }) {
  const [css, setCss] = useState(true);
  const [dom, setDom] = useState(false);
  const [react, setReact] = useState(false);
  const [canvas, setCanvas] = useState(false);
  const [libraries, setLibraries] = useState(false);
  const [previousScroll, setPreviousScroll] = useState(0);
  const [isHeaderHidden, setIsHeaderHidden] = useState(false);

  function cssHandler() {
    setCss(true);
    setDom(false);
    setReact(false);
    setCanvas(false);
  }
  function domHandler() {
    setCss(false);
    setDom(true);
    setReact(false);
    setCanvas(false);
    setLibraries(false)
  }
  function reactHandler() {
    setCss(false);
    setDom(false);
    setReact(true);
    setCanvas(false);
    setLibraries(false);
  }
  function canvasHandler() {
    setCss(false);
    setDom(false);
    setReact(false);
    setCanvas(true);
    setLibraries(false);
  }
  function librariesHandler() {
    setCss(false);
    setDom(false);
    setReact(false);
    setCanvas(false);
    setLibraries(true);
  }

  const navigate = useNavigate();

  function homeHandler() {
    navigate("/portfolio-last");
    setHome(true);
    setAboutMe(false);
    setContact(false);
  }
  function aboutMeHandler() {
    navigate("/portfolio-last/aboutme");
    setAboutMe(true);
    setHome(false);
    setContact(false);
  }
  function contactHandler() {
    navigate("/portfolio-last/contact");
    setContact(true);
    setHome(false);
    setAboutMe(false);
  }
  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      if (currentScroll > previousScroll) {
        setIsHeaderHidden(true);
      } else if (currentScroll < previousScroll && currentScroll === 0) {
        setIsHeaderHidden(false);
        cssHandler();
      }

      setPreviousScroll(currentScroll);
    };

    // Add the event listener when the component mounts
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [previousScroll]); // Dependency array to ensure the effect runs only when previousScroll changes
  return (
    <>
      <header style={{ display: isHeaderHidden ? "none" : "block" }}>
        <section>
          <div
            onClick={homeHandler}
            style={{ color: `${home ? "#00e2ff" : "#ffffffc0"}` }}
          >
            Projects
          </div>
          <div
            onClick={aboutMeHandler}
            style={{ color: `${aboutMe ? "#00e2ff" : "#ffffffc0"}` }}
          >
            About me
          </div>
          <div
            onClick={contactHandler}
            style={{ color: `${contact ? "#00e2ff" : "#ffffffc0"}` }}
          >
            Contact
          </div>
        </section>
        <section
          className="sort"
          style={home ? { display: "flex" } : { display: "none" }}
        >
          <div>
            <a
              href="#css"
              onClick={cssHandler}
              style={css ? { color: "#e8ff00" } : {}}
            >
              Css
            </a>
          </div>

          <div>
            <a
              href="#dom"
              onClick={domHandler}
              style={dom ? { color: "#e8ff00" } : { "--c": "#e8ff00" }}
            >
              Dom
            </a>
          </div>

          <div>
            <a
              href="#react"
              onClick={reactHandler}
              style={react ? { color: "#e8ff00" } : { "--c": "#e8ff00" }}
            >
              React
            </a>
          </div>
          <div>
            <a
              href="#canvas"
              onClick={canvasHandler}
              style={canvas ? { color: "#e8ff00" } : { "--c": "#e8ff00" }}
            >
              Canvas
            </a>
          </div>
          <div>
            <a
              href="#libraries"
              onClick={librariesHandler}
              style={libraries ? { color: "#e8ff00" } : { "--c": "#e8ff00" }}
            >
              Libraries
            </a>
          </div>
        </section>
      </header>
    </>
  );
}

export default Header;
